
//
// Payment Controller
//
// Integrates Stripe to fetch charge token to submit to backend for processing.
// Also provides some debug functions to save typing stuff over and over again.
//

module.exports = function PaymentController ($page, $$) {

  var $form             = $$('form');
  var $submitButtonHost = $$('[data-submit-button-host]');
  var $nojsMessage      = $$('[data-nojs-message]');
  var contactAddress    = $nojsMessage.data('contact-addr');


  //
  // Stripe Integration
  //

  if (typeof Stripe !== 'undefined' && typeof STRIPE_PUBLIC_KEY === 'string' && STRIPE_PUBLIC_KEY !== '') {

    Stripe.setPublishableKey(STRIPE_PUBLIC_KEY);

    // Functions
    function generateToken (event) {
      form.querySelector('button').disabled = true;
      Stripe.card.createToken(form, stripeResponseHandler);
      $form.animate({ opacity: 0.5 }, 200);
      event.preventDefault();
    };

    function stripeResponseHandler (status, response) {
      $form.animate({ opacity: 1 }, 200);
      if (response.error) {
        form.querySelector('.form-errors').textContent = response.error.message;
        form.querySelector('button').disabled = false;
      } else {
        form.querySelector('.hidden').innerHTML = '<input type="text" name="token">';
        form.querySelector('[name="token"]').value = response.id;
        form.submit();
      }
    };

    // Listeners
    var form = document.querySelector('[data-form="stripe"]');
    form.addEventListener('submit', generateToken);
  }


  //
  // Helper Functions
  //

  function enableSubmitButton () {
    var $submit = $('<button class="add-to-cart theme-button" type="submit">Buy Now</button>');
    $nojsMessage.parent().append($submit)
    $nojsMessage.remove();
  }

  function checkForStripeAndJavascript () {
    if (typeof Stripe === 'undefined') {

      $nojsMessage.html(
        '<a href="https://stripe.com" target="_blank">Stripe</a> is being blocked on this page.<br>' +
        'We need Stripe to process your payment; please temporarily disable or white-list any ' +
        'Ad-Blockers or other plugins that might be blocking Stripe, and then refresh this page to continue.<br><br>' +
        'If you cannot resolve this error, contact us <a href="mailto:' + contactAddress + '">here</a> and we\'ll assist you.');

    } else if (typeof STRIPE_PUBLIC_KEY !== 'string' || STRIPE_PUBLIC_KEY == '') {

      $nojsMessage.html(
        'Stripe is not configured correctly (public key is not available). <br>' +
        'Please let us know and we\'ll sort it out as soon as we can.');

    } else {
      enableSubmitButton();
    }
  }


  //
  // Debug Functions
  //

  var $debugFillButtons = $$('[data-debug-fill]');

  // Functions
  function fillById (name, value) {
    var input = document.querySelector('#_' + name);
    if (input) input.value = value;
  }

  function debugFillCommon () {
    fillById('number',  '4242 4242 4242 4242');
    fillById('cvc',     '456');
    fillById('month',   '12');
    fillById('year',    '29');
    fillById('address', "123 Fake Street\nSomeplace\nSomewhere, 1111");
  }

  function debugFillDispatch (type) {
    debugFillCommon();

    switch (type) {
      case 'error':
        fillById('number',  'xxxx');
        fillById('name',  'Jordan');
        fillById('email', 'jordan@ghost.st');
        break;

      case 'ghost':
        fillById('name',  'Jordan');
        fillById('email', 'jordan@ghost.st');
        break;

      case 'luna':
        fillById('name',  'Lunagroup');
        fillById('email', 'marketing@onetreegrill.co.nz');
        break;
    }
  }

  // Listeners
  $debugFillButtons.on('click', function () {
    var type = $(this).data('debug-fill');
    debugFillDispatch(type);
  });


  // Init
  checkForStripeAndJavascript();

};

